import { useState, useCallback, useEffect } from "react"

/**
 * Dynamic import of modules.
 */
const useLazyImport = (importFn, condition = true) => {
  const [module, setModule] = useState(null)
  const importModule = useCallback(async () => {
    setModule(await importFn())
  }, [setModule])

  useEffect(() => {
    if (!module && condition) importModule()
  }, [module, condition])

  return module
}

export default useLazyImport
